import { apiService } from './api.service';
import { CR_API_ENDPOINTS } from '../constants';
import { ModuleBrand } from '../types';

class ModuleBrandsService {
  async getAllBrands(): Promise<ModuleBrand[]> {
    return apiService.get<ModuleBrand[]>(CR_API_ENDPOINTS.MODULE_BRANDS);
  }

  async getBrandById(id: string): Promise<ModuleBrand> {
    return apiService.get<ModuleBrand>(`${CR_API_ENDPOINTS.MODULE_BRANDS}/${id}`);
  }

  async createBrand(brandData: { name: string }): Promise<ModuleBrand> {
    return apiService.post<ModuleBrand>(CR_API_ENDPOINTS.MODULE_BRANDS, brandData);
  }
}

export const moduleBrandsService = new ModuleBrandsService();